import openingDiscountLetter from 'src/images/gifs/campaigns/flash-sales/opening-discount-letter.gif';
import styled, { css } from 'styled-components';

export const StyledBanner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.6rem;
  min-height: 55.5rem;
  padding: 3rem 1.8rem 18rem;
  position: relative;
  overflow: hidden;
  background: linear-gradient(91deg, #1C2538 42.32%, #3D63AE 99.39%);

  z-index: 0;

  @media screen and (min-width: 576px) {
    min-height: 37.7rem;
    padding: 4.6rem;
  }

  & > div {
    z-index: 10;
  }
`;

export const StyledTitle = styled.h2`
  color: ${({ theme }) => theme.colors.text.main};
  letter-spacing: -0.96px;
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  margin-bottom: 0rem;

  font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
  text-align: left;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  @media screen and (max-width: 576px) {
    max-width: 100%;
  }
`;

export const StyledSubTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
  margin-bottom: 0rem;

  text-align: left;
  font-size: ${({ theme }) => theme.fonts.sizes.large};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  max-width: 45.1rem;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
    font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  }

  @media screen and (max-width: 576px) {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    line-height: 2rem;
    max-width: 100%;
  }
`;

export const StyledSubTitleAlt = styled(StyledSubTitle)`
  font-size: ${({ theme }) => theme.fonts.sizes.large};
  line-height: 3rem;
  max-width: 100%;

  @media screen and (max-width: 576px) {
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
    line-height: 2.3rem;
  }
`;

export const StyledButtons = styled.div`
  display: flex;
  gap: 1.6rem;
`;

export const StyledCountdownContainer = styled.div`
  padding: 0.8rem 0rem 0rem;
`;

export const StyledOpeningDiscountLetter = styled.img.attrs({
  src: openingDiscountLetter,
})<{ $large: boolean }>`
  position: absolute;
  z-index: 1;

  ${({ $large }) =>
    $large
      ? css`
    width: 55rem;
    right: 0rem;
    bottom: 50%;
    transform: translateY(50%);
  `
      : css`
    width: 30rem;
    bottom: 0.8rem;
    right: 2.9rem;
    transform: none;
  `}

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    width: 30rem;
    bottom: 0.8rem;
    right: 2.9rem;
    transform: none;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 27rem;
    right: 3rem;
    bottom: 1.2rem;
    transform: none;
  }

  @media screen and (max-width: 576px) {
    width: 22.2rem;
    bottom: 0;
    right: 50%;
    transform: translateX(50%);
  }
`;
